<template>
    <Card :padding="0">
        <div v-if="cardType=='dataSupervise'||cardType=='newDataSupervise'">
            <count-up
                :end-val="endVal"
                :startDataVal="startDataVal"
                :numStyleObj="numStyleObj"
                :nameStyleObj="nameStyleObj"
                :cardType="cardType"
                :introText="introText"
                :isConvert="isConvert"
                >
            </count-up>
        </div>
        <div class="infor-card-con" v-else>
            <Col class="infor-card-icon-con" :style="{background: color, color: 'white'}" span="8">
                <Row :class="iconStyle" type="flex" align="middle" justify="center">
                    <div>
                        <Icon :custom="iconCustom" :size="iconSize" v-if="iconCustom!=''"/>
                        <Icon :type="iconType" :size="iconSize" v-else/>
                    </div>
                </Row>
            </Col>
            <Col span="16" class="height-100">
                <Row type="flex" align="middle" justify="center" :class="countStyle">
                    <count-up
                        class="infor-card-count user-created-count"
                        :id-name="idName"
                        :end-val="endVal"
                        :decimals="decimals"
                        :color="textColor"
                        :countSize="countSize"
                        :countWeight="countWeight"
                        :options="options">
                        <p class="infor-intro-text" slot="intro">{{ introText }}</p>
                        <p class="infor-intro-text-add" slot="intro">{{ introTextAdd }}</p>
                    </count-up>
                </Row>
            </Col>
        </div>
    </Card>
</template>

<script>
    import countUp from './countUp.vue';

    export default {
        name: 'inforCard',
        components: {
            countUp
        },
        props: {
            cardType: String,
            idName: String,
            isConvert: {
                type: Number,
                default: -1
            },
            startDataVal: {
                type: Number,
                default: 0
            },
            endVal: {
                type: Number,
                default: 0
            },
            decimals: {
                type: Number,
                default: 0
            },
            color: String,
            iconType: String,
            introText: String,
            introTextAdd: String,
            countSize: {
                type: String,
                default: '30px'
            },
            countWeight: {
                type: Number,
                default: 700
            },
            iconSize: {
                type: Number,
                default: 40
            },
            textColor: String,
            iconCustom: {
                type: String,
                default: ''
            },
            numStyleObj: Object,
            nameStyleObj: Object,
            options: {
                type: Object,
                default: () => {
                    return {
                        useEasing: true,
                        useGrouping: true,
                        separator: ',',
                        decimal: '.',
                        suffix: ''
                    };
                }
            }
        },
        data () {
            return {
                iconStyle: 'height-100',
                countStyle: 'height-100'
            }
        },
        methods: {

        },
        mounted(){
        }
    };
</script>
<style lang="scss">
    .num {
        /*font-family: MaravaleExpanded;*/
        color: #0efcff;
        font-size: 28px;
        transform: scale(1, 1.3);
        -ms-transform: scale(1, 1.3);
        -webkit-transform: scale(1, 1.3);
        -moz-transform: scale(1, 1.3);
        -o-transform: scale(1, 1.3);
    }

    .name {
        font-size: 12px;
        color: #708acc;
        margin-top: -4px;
    }

    .infor-card-icon-con {
        height: 100%;
    }

    .height-100 {
        height: 100%;
    }

    .height-100-center {
        height: 100%;
        position: absolute;
        left: 30%;
        top: 30%;
    }

    .height-100-count-center {
        height: 100%;
        position: absolute;
        left: 40%;
        top: 20%;
    }

    .infor-card-con {
        height: 120px;
    }

    .infor-intro-text {
        font-size: 12px;
        font-weight: 500;
        color: #c8c8c8;
        text-align: center;
    }

    .infor-intro-text-add {
        font-size: 12px;
        font-weight: 500;
        color: #f43838;
        text-align: center;
    }
</style>

